import { buildHeaderMarkdown } from '../api/documentMarkdown';

import type { DocumentDraftStore } from './documentDraftStore';

const REFERRAL_SECTIONS = [
  '## Reason for referral',
  '## Clinical summary',
  '## Relevant history and medications',
  '## Requested evaluation',
];

/** Matches REFERRAL_DRAFTS_SHELF_KEY in lotushealth.referrals. */
export const REFERRAL_DRAFT_STORE: DocumentDraftStore = {
  shelfKey: 'referral-drafts-v1',
  kind: 'referral-drafts',
  schemaVersion: 1,
  buildNewDraftMarkdown: (header) =>
    [
      buildHeaderMarkdown('Subject', [
        ['To', header.recipient.name],
        ['Organization', header.recipient.organization],
        ['Fax', header.recipient.faxNumber],
        ['Date', header.date],
        ['From', header.prescriberName],
        ['Patient', header.patientName],
        ['Date of birth', header.patientDateOfBirth],
      ]),
      ...REFERRAL_SECTIONS,
      '',
    ].join('\n\n'),
};
